var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import SrmDebugConstants from "../models/SrmDebugConstants.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let SrmDebugResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/xCardApi/workspaces");
  }
  getSrmDebugCheckRestResult(request, workspaceId) {
    return __async(this, null, function* () {
      const address = `/${workspaceId}/enrichment-sample-ratio-mismatch?api-version=2022-12-01-internal`;
      const body = {
        scorecardId: request.ScorecardId,
        Treatment: request.Treatment,
        Control: request.Control,
        PrimarySegmentName: request.PrimarySegmentName,
        PrimarySegmentValue: request.PrimarySegmentValue,
        SecondarySegmentName: SrmDebugConstants.SEGMENT_AGGREGATE,
        SecondarySegmentValue: SrmDebugConstants.SEGMENT_AGGREGATE
      };
      return yield this._post(body, address);
    });
  }
};
__decorateClass([
  onError({ message: `An error occured while getting features.` })
], SrmDebugResource.prototype, "getSrmDebugCheckRestResult", 1);
SrmDebugResource = __decorateClass([
  WPSProxyConverter()
], SrmDebugResource);
const SrmDebugResource$1 = new SrmDebugResource();
export {
  SrmDebugResource$1 as default
};
//# sourceMappingURL=SrmDebug.resource.js.map
